module.exports = __webpack_public_path__ + "static/media/service_system_1.e4cf14bf.png";